import { format, parseISO } from 'date-fns';

import {
  type AssignedCompanyRole,
  CompanyRole,
  type TransitionInput as Transition,
} from '@/api/client';

import type {
  PropertyTransitionSettingsCreateFormValues,
  PropertyTransitionSettingsEditFormValues,
  PropertyTransitionSettingsFormValues,
} from '../property-transitions-types';

const parseIsoDate = (iso: string | null | undefined): Date | undefined => {
  if (!iso) return undefined;
  const head = iso.split('T')[0] ?? '';
  if (!head) return undefined;
  try {
    return parseISO(head);
  } catch {
    return undefined;
  }
};

export const companyRolesFromFormValues = (
  data: PropertyTransitionSettingsFormValues
): AssignedCompanyRole[] => {
  const roles: AssignedCompanyRole[] = [
    {
      role: CompanyRole.FromManager,
      company_id: data.fromManagerCompanyId,
    },
    {
      role: CompanyRole.ToManager,
      company_id: data.toManagerCompanyId,
    },
    {
      role: CompanyRole.FromOwner,
      company_id: data.fromOwnerCompanyId,
    },
  ];
  const toOwner = data.toOwnerCompanyId?.trim();
  if (toOwner) {
    roles.push({ role: CompanyRole.ToOwner, company_id: toOwner });
  }
  return roles;
};

export const formValuesFromTransition = (
  transition: Transition
): PropertyTransitionSettingsEditFormValues => ({
  name: transition.name ?? '',
  targetCompletionDate: parseIsoDate(transition.target_completion_date),
});

export const createFormDefaultValues =
  (): PropertyTransitionSettingsCreateFormValues => ({
    name: '',
    targetCompletionDate: undefined,
    templateIds: [],
    fromManagerCompanyId: '',
    toManagerCompanyId: '',
    fromOwnerCompanyId: '',
    toOwnerCompanyId: '',
  });

export const formatTargetCompletionDate = (date: Date): string =>
  format(date, 'yyyy-MM-dd');
